import { render, staticRenderFns } from "./shipment-bill-logistics-fee.vue?vue&type=template&id=453a54a9&scoped=true&"
import script from "./shipment-bill-logistics-fee.vue?vue&type=script&lang=js&"
export * from "./shipment-bill-logistics-fee.vue?vue&type=script&lang=js&"
import style0 from "./shipment-bill-logistics-fee.vue?vue&type=style&index=0&id=453a54a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a54a9",
  null
  
)

export default component.exports